export default {

  /**
   * @param score
   * @returns {string}
   */
  doubleRoundScore(score) {
    return Number(score * 2).toFixed(1);
  },
};



// WEBPACK FOOTER //
// ./src/services/review-service.js